import TracksPage from "./TracksPage";

export default TracksPage;